import { render } from "./TraningBlocSubscriptionsTable.vue?vue&type=template&id=28046146"
import script from "./TraningBlocSubscriptionsTable.vue?vue&type=script&lang=js"
export * from "./TraningBlocSubscriptionsTable.vue?vue&type=script&lang=js"

import "./TraningBlocSubscriptionsTable.vue?vue&type=style&index=0&id=28046146&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__